/**
 * Empório Saibai — normaliza a galeria PDP como carousel nativo.
 * O markup, thumbs, navegação e sincronização continuam no runtime Ella/Swiper.
 * Build 2026-08-08.
 */
(() => {
  'use strict';
  if (window.__saibaiPdpGalleryModeInit) return;
  window.__saibaiPdpGalleryModeInit = true;

  const selector = 'body.template-product .product-information__media media-gallery';
  let frame = 0;

  const normalize = (gallery) => {
    if (!(gallery instanceof HTMLElement)) return;

    gallery.classList.remove(
      'media-gallery--grid',
      'media-gallery--one-column',
      'media-gallery--two-column',
      'media-gallery--large-first-image'
    );
    gallery.classList.add('media-gallery--carousel', 'saibai-standard-gallery');
    gallery.dataset.presentation = 'carousel';

    const grid = gallery.querySelector('.media-gallery__grid');
    if (grid) {
      grid.hidden = true;
      grid.setAttribute('aria-hidden', 'true');
    }

    const component = gallery.querySelector('swiper-component.saibai-native-product-gallery');
    if (component) {
      component.hidden = false;
      component.removeAttribute('aria-hidden');
      const swiper = component.initSwiper || component.querySelector('.swiper-main')?.swiper;
      swiper?.update?.();
      swiper?.updateAutoHeight?.(0);
    }
  };

  const init = () => document.querySelectorAll(selector).forEach(normalize);
  const schedule = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(init);
  };

  const boot = () => {
    init();
    const root = document.querySelector('#MainContent') || document.body;
    if (!root || typeof MutationObserver !== 'function') return;

    new MutationObserver((records) => {
      const changed = records.some((record) =>
        [...record.addedNodes].some((node) =>
          node instanceof Element &&
          (node.matches?.('media-gallery') || node.querySelector?.('media-gallery'))
        )
      );
      if (changed) schedule();
    }).observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', schedule);
})();
